module.exports = __webpack_public_path__ + "img/kaart-oplossing.d01f3277.png";